module.exports = __webpack_public_path__ + "triangle_arrow.73b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/triangle_arrow.svg
// module id = ./src/_asset/sources/assets/images/@svg/triangle_arrow.svg
// module chunks = main